/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Heading, HFlow, Icon, Theme, useTheme, VFlow } from 'bold-ui'
import { useEffect, useMemo, useRef } from 'react'

import { MChatRfModalButtonClose } from '../../components/MChatRfModalButtonClose'
import { convertMChatToPerguntaRespostaInput } from '../converter-mchat'
import { downloadMChat } from '../impressao/downloadMChat'
import { MChatResultadoView } from '../mchat-resultado/MChatResultadoView'
import { MChatFieldModel } from '../model-mchat'

interface MChatModalTabResultadoProps {
  values: MChatFieldModel
  atendProfId: ID
  cidadaoId: ID
  isEditing: boolean
  onClickVoltar: () => void
  onClose: () => void
}

export function MChatModalTabResultado(props: Readonly<MChatModalTabResultadoProps>) {
  const { values, atendProfId, cidadaoId, isEditing, onClickVoltar, onClose } = props

  const theme = useTheme()
  const styles = useMemo(() => createStyles(theme), [theme])
  const backButtonRef = useRef<HTMLButtonElement>()

  const handlePrint = (atendProfId: ID, cidadaoId: ID, mchat: MChatFieldModel) => {
    downloadMChat({
      atendProfId: atendProfId,
      cidadaoId: cidadaoId,
      resultado: mchat.resultado,
      risco: mchat.risco,
      aplicacao: convertMChatToPerguntaRespostaInput(mchat),
    })
  }

  useEffect(() => {
    backButtonRef?.current.focus()
  }, [])

  return (
    <VFlow>
      <HFlow alignItems='flex-start' justifyContent='space-between'>
        <Button kind='normal' size='small' style={styles.voltarButton} onClick={onClickVoltar} innerRef={backButtonRef}>
          <Icon icon='arrowLeft' style={styles.icons} />
          {isEditing ? 'Voltar à edição' : 'Editar a avaliação'}
        </Button>
        <MChatRfModalButtonClose onClose={onClose} />
      </HFlow>
      <VFlow style={styles.modalSectionBody}>
        <HFlow alignItems='center' justifyContent='space-between'>
          <Heading level={1}>Resultado M-CHAT-R™</Heading>
          <Button
            kind='normal'
            size='small'
            style={styles.imprimirButton}
            onClick={(event) => {
              event.stopPropagation()
              handlePrint(atendProfId, cidadaoId, values)
            }}
          >
            <Icon icon='printerOutline' style={styles.icons} />
            Imprimir resultado
          </Button>
        </HFlow>
        <MChatResultadoView isInsideModal values={values} />
      </VFlow>
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  icons: css`
    margin-right: 0.5rem;
  `,
  voltarButton: css`
    margin-bottom: 1rem;
  `,
  imprimirButton: css`
    color: ${theme.pallete.primary.main};
    border-color: ${theme.pallete.primary.main};
  `,
  modalSectionBody: css`
    padding-right: 1rem;
  `,
})
